import { logoSrc } from "../lib/api";

export default function ClientLogo({ client, className = "h-10 w-10", testId }) {
  const src = logoSrc(client);
  if (src) {
    return <img src={src} alt={client?.name || "Logo"} className={`${className} rounded-full object-contain bg-white`} data-testid={testId} />;
  }
  const initials = (client?.name || "DA").slice(0, 2).toUpperCase();
  return (
    <div
      className={`${className} rounded-full bg-slate-900 text-white font-display font-bold flex items-center justify-center`}
      data-testid={testId}
    >
      {initials}
    </div>
  );
}
